import { render, staticRenderFns } from "./BlockContactModal.vue?vue&type=template&id=265662b7&scoped=true&"
import script from "./BlockContactModal.vue?vue&type=script&lang=js&"
export * from "./BlockContactModal.vue?vue&type=script&lang=js&"
import style0 from "./BlockContactModal.vue?vue&type=style&index=0&id=265662b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265662b7",
  null
  
)

export default component.exports